import { render, staticRenderFns } from "./driverOrdersPage.vue?vue&type=template&id=69703a19&scoped=true"
import script from "./driverOrdersPage.vue?vue&type=script&lang=js"
export * from "./driverOrdersPage.vue?vue&type=script&lang=js"
import style0 from "./driverOrdersPage.vue?vue&type=style&index=0&id=69703a19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69703a19",
  null
  
)

export default component.exports